import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getMeetingSlots, getTimezone } from '../store/giftFlow/giftFlow.selectors';
import { ISlot } from '../store/meeting/meeting.types';
import { getStatuses } from '../store/statuses/statuses.selectors';

export default (): {
  isSingleSlotFlow: boolean;
  isMultiSlotFlow: boolean;
  timezoneName: string;
  meetingSlots: ISlot[] | null;
} => {
  const timezoneName = useSelector(getTimezone);
  const meetingSlots = useSelector(getMeetingSlots);
  const { hasIntegration } = useSelector(getStatuses);

  const hasMeeting = Boolean(meetingSlots && meetingSlots.length > 0);
  const isSingleSlotFlow = hasMeeting && hasIntegration;
  const isMultiSlotFlow = hasMeeting && !hasIntegration;

  return useMemo(
    () => ({
      isSingleSlotFlow,
      isMultiSlotFlow,
      timezoneName,
      meetingSlots,
    }),
    [isSingleSlotFlow, isMultiSlotFlow, timezoneName, meetingSlots],
  );
};
